import { render, staticRenderFns } from "./Registrarse.vue?vue&type=template&id=00ed0904&lang=pug"
import script from "./Registrarse.vue?vue&type=script&lang=js"
export * from "./Registrarse.vue?vue&type=script&lang=js"
import style0 from "./Registrarse.vue?vue&type=style&index=0&id=00ed0904&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports